import type { ReactNode } from 'react';
import { READER_TEST_IDS } from './contracts';

export interface FeedbackThanksProps {
  /** The phrase of thanks of the feedback page (`feedbackThanksOf`): plain text, no variable. */
  readonly text: string;
}

/**
 * What the feedback page says once the feedback is SENT (retour-experience.md
 * §5, §6.2; issue #176): the phrase of thanks, and nothing else.
 *
 * « Le lecteur remplace les blocs de la page par la phrase de remerciement,
 * peinte au style de texte du thème, sans bouton. Le dispositif n'ajoute pas
 * d'autre écran. » So this is the reading column of the page it replaces, in
 * the very frame that paints the theme - the background, the veil and the face
 * are the reader's, which is why the phrase lives HERE and not in a panel of
 * the session - with ONE paragraph in it, the style of a Texte block.
 *
 * Centred in the HEIGHT of the window and aligned to the left, like an ordinary
 * block (the mockup `lecteur-retour.html`, choix de forme 6); it appears with
 * the fade every page's first block has, which reduced motion removes like any
 * other. A `status` for a screen reader: the click that sent the feedback has
 * just removed the button it came from, and nothing else says what happened.
 *
 * Plain text because the phrase accepts no variable (§2): React owns the markup,
 * and a `{{` in it is a refusal of the save, never something to resolve here.
 */
export function FeedbackThanks({ text }: FeedbackThanksProps): ReactNode {
  return (
    <div className="lecteur-colonne" data-centered="true">
      <div
        className="lecteur-bloc lecteur-anim lecteur-merci"
        data-testid={READER_TEST_IDS.thanks}
        data-animation="fade"
        // biome-ignore lint/a11y/useSemanticElements: `<output>` is inline and form-bound; this is a block of the page announced once
        role="status"
      >
        <p className="lecteur-texte">{text}</p>
      </div>
    </div>
  );
}
